<div class="row">
    <div class="col-md-8 position-relative multimarket_ui">
        <div class="sub_path">
            <p class="detail-title">
                Multi Market
            </p>
            <p class="liveTv mobile-television">
                <a class="bet" href="javascript:void(0)" *ngIf="isLogin();" (click)="openModal(openBets,'bets')">bets</a>
            </p>
        </div>
        <div class="detailScreen">
            <div class="row">
                <!-- mobile tv -->
                <div class="mobile-television">
                    <div id="collapseBasic" [collapse]="isCollapsed.tv.mobile" [isAnimated]="true">
                        <div id="tv-block-id-mob" class="embed-responsive embed-responsive-16by9">

                        </div>
                    </div>
                </div>
                <!--/ mobile tv -->
                <div class="col-12" id="MarketsCollapse">

                    <div class="" *ngIf="data">

                        <div class="" *ngFor="let dt of data;let di=index;trackBy:trackByIndex;">
            
                            <div class="multim_title" (click)="detailPage(dt[0])">
                                {{dt[0]?.event?.name ? dt[0]?.event?.name : dt[0]?.name}}
                                <div class="pull-right">
                                    <a href="javascript:void(0)" (click)="detailPage(dt[0])" class="UserChipData">
                                        <i class="fa fa-angle-double-right"></i>
                                    </a>
                                </div>
                            </div>                        
                            <div id="" *ngFor="let item of dt;let j=index;trackBy:trackByIndex">
                                <!-- MATCH ODDS -->
                                <div class="market_section_parent1" *ngIf="item?.market_id[0] && item?.market_id[0] == '1'">
                                    <!-- market section start -->
                                    <div class="market_section">
                                        <p>
                                            <a href="javascript:void(0);" class="add-pin"
                                                *ngIf="isLogin() && !multiMarketIds.includes(item?.market_id)"
                                                (click)="multiMarketUpdate(item, 'save')"> <i
                                                    class="fa fa-location-arrow"></i> </a>
                                            <a href="javascript:void(0);" class="add-unpin"
                                                *ngIf="isLogin() && multiMarketIds.includes(item?.market_id)"
                                                (click)="multiMarketUpdate(item, 'remove')"> <i
                                                    class="fa fa-location-arrow"></i> </a>
                                            <span class="mrkname">{{item?.market?.market_name}}</span>
                                            <span class="min-max">
                                                Min: {{item?.market?.min_bet}} | Max:
                                                {{item?.market?.max_bet}}
                                                <span class="matched-count"
                                                    *ngIf="oddsLisDis[item?.market_id]?.totalMatched">
                                                    Matched: {{oddsLisDis[item?.market_id]?.totalMatched}}
                                                </span>
                                                <!-- <b data-toggle="collapse" href="#MO" aria-expanded="true" aria-controls="Mo">
                                                    <i class="fa fa-minus mdi mdi-minus accordion-arrow"></i>
                                                </b> -->
                                            </span>
                                            <a href="javascript:void(0)" (click)="openModal(ruleModal, 'rule')">
                                                <i class="fa fa-info-circle"></i>
                                            </a>
                                            <!-- <span>
                                                <button class="btn-cashout" *ngIf="isLogin() && item?.runners.length == 2" (click)="cashOut(data?.event?.match_odds,'match_odds')">Cashout</button>                                    
                                            </span> -->
                                        </p>
                                        <div id="MO" class="collapse show">
                                            <div class="row align-items-center oddsHeader">
                                                <div class="col-lg-6 col-md-5 col-8 px-0">
                                                </div>
                                                <div class="col-lg-6 col-md-7 col-4 px-0">
                                                    <div class="btn-group">
                                                        <button class="ex-bl"></button>
                                                        <button class="ex-bl"></button>
                                                        <button class="back">back</button>
                                                        <button class="lay">lay</button>
                                                        <button class="ex-bl"></button>
                                                        <button class="ex-bl"></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <app-market-detail
                                            [data]="{marketData: item, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, betSlipData: betSlipData}"
                                            (betDt)="openBetPlace($event)" (closeBet)="closeBet($event)"
                                            (updateData)="updateData($event)"
                                            (changeExpo)="changeExpo($event)"></app-market-detail>
                                        </div>
                                    </div>
                                    <!-- market section end -->
                                </div>
                                <!-- /MATCH ODDS -->
                                <!-- BOOK MAKER -->
                                <div class="market_section_parent1" *ngIf="item?.market_id[0] && item?.market_id[0] == '8'">
                                    <div class="market_section" *ngIf="item?.market_id[0] && item?.market_id[0] == '8'">
                                        <p>
                                            <a href="javascript:void(0);" class="add-pin" *ngIf="isLogin() && !multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')"> <i class="fa fa-location-arrow"></i> </a>
                                            <a href="javascript:void(0);" class="add-unpin" *ngIf="isLogin() && multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')"> <i class="fa fa-location-arrow"></i> </a>
                                            <span class="mrkname">{{item?.bookmaker?.title}}</span>
                                            <span class="min-max">
                                                Min: {{item?.bookmaker?.min_bet}} | Max: {{item?.bookmaker?.min_bet}}
                                                <span class="matched-count" *ngIf="oddsLisDis[item?.market_id]?.totalMatched">| Matched:
                                                    {{oddsLisDis[item?.market_id]?.totalMatched}}</span>
                                                <!-- <b data-toggle="collapse" href="#BM" aria-expanded="true" aria-controls="BM">
                                                    <i class="fa fa-minus mdi mdi-minus accordion-arrow"></i>
                                                </b> -->
                                            </span>
                                            <a href="javascript:void(0)" (click)="openModal(ruleModal, 'rule')">
                                                <i class="fa fa-info-circle"></i>
                                            </a>
                                        </p>
                                        <div id="BM" class="collapse show">
                                            <div class="row align-items-center oddsHeader">
                                                <div class="col-lg-6 col-md-5 col-8 px-0">
                                                </div>
                                                <div class="col-lg-6 col-md-7 col-4 px-0">
                                                    <div class="btn-group">
                                                        <button class="ex-bl"></button>
                                                        <button class="ex-bl"></button>
                                                        <button class="back">back</button>
                                                        <button class="lay">lay</button>
                                                        <button class="ex-bl"></button>
                                                        <button class="ex-bl"></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <app-bookmaker-detail [data]="{marketData: oddsLisDis[item?.market_id], odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, betSlipData: betSlipData}"
                                            (betDt)="openBetPlace($event)" (closeBet)="closeBet($event)"
                                            (updateData)="updateData($event)"
                                            (changeExpo)="changeExpo($event)"></app-bookmaker-detail>
                                        </div>
                                    </div>
                                </div>
                                <!-- /BOOK MAKER -->
                                <!-- FANCY -->
                                <div class="market_section twoOddsSection" *ngIf="item?.market_id[0] && item?.market_id[0] == '9'">
                                    <span class="fancyTitle">Line</span>
                                    <div class="row align-items-center oddsHeader">
                                        <div class="col-lg-6 col-md-5 col-8 px-0">
                                        </div>
                                        <div class="col-lg-6 col-md-7 col-4 px-0">
                                            <div class="btn-group">
                                                <button class="ex-bl"></button>
                                                <button class="ex-bl"></button>
                                                <button class="lay">no</button>
                                                <button class="back">yes</button>
                                                <button class="ex-bl"></button>
                                                <button class="ex-bl"></button>
                                            </div>
                                        </div>
                                    </div>
                                    <app-fancy-detail [data]="{fancyData: item?.data, tabVal:item?.allFancy, isFancy:true, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, multiMarketIds: multiMarketIds, betSlipData: betSlipData}"
                                    (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"
                                    (closeBet)="closeBet($event)" (updateData)="updateData($event)"
                                    (changeExpo)="changeExpo($event)"></app-fancy-detail>
                                </div>
                                <!-- FANCY -->
                            </div>                        
                        </div>                    
                    </div>                    
                </div>
            </div>
        </div>
        <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
    </div>
    <!-- end col-->
    <div class="col-md-4 px-0 rightBar col-md-4 px-0 multimarket_ui" [ngClass]="{ 'bestlip-fixed': scrolled }">
        <app-bet-list [callGetData]="callGetData" (apiCalled)="callGetData = false;" *ngIf="isLogin();"></app-bet-list>
        <app-bet-slip [data]="betSlipData" (closeBet)="closeBet($event)" (updateData)="updateData($event)" (changeExpo)="changeExpo($event)"></app-bet-slip>
    </div>
</div>
<!-- end row -->


<ng-template #openBets>
    <div class="modal-header">
        <h4 class="modal-title mt-0">Open Bets</h4>
        <button type="button" class="close" (click)="modalRef?.hide()">×</button>
    </div>
    <div class="modal-body">
        <app-bet-list></app-bet-list>
    </div>
</ng-template>

<ng-template #ruleModal>
    <div class="modal-header">
        <h4 class="modal-title mt-0">Book</h4>
        <button type="button" class="close" (click)="modalRef?.hide()">×</button>
    </div>
    <div class="modal-body">
        <p>1. Cricket General :- ➢ If a ball is not bowled during a competition, series or match then all bets will be
            void except for those on any market that has been unconditionally determined (e.g. in the 'Completed Match'
            market).</p>

        <p>2. Cricket General :- If a match is shortened by weather, all bets will be settled according to the official
            result (including for limited overs matches, the result determined by the Duckworth Lewis method).</p>

        <p>3. Cricket General :- In the event of a match being decided by a bowl-off or toss of the coin, all bets will
            be void except for those on markets that have been unconditionally determined.</p>

        <p>4. Cricket Test matches :- If a match starts but is later abandoned for any reason other than weather (which
            may include but is not limited to: dangerous or unplayable wicket or outfield; pitch vandalism; strike or
            boycott; crowd protests/violence; stadium damage; acts of terrorism; and acts of God), Betfair reserves the
            right to
            void all bets, except for those on markets that have been unconditionally determined.</p>

        <p>5. In case anyone is found using 2 different IDs and logging in from same IP his winning in both accounts
            will be cancelled.</p>

        <p>6. Cricket Test matches :- If the match is not scheduled to be completed within five days after the original
            scheduled completion date, then all bets on markets for this event will be void, except for bets on any
            markets that have been unconditionally determined.</p>

        <p>7. Cricket Limited Over matches :- If a match is declared (No Result), bets will be void on all markets for
            the event except for those markets which have been unconditionally determined or where the minimum number of
            overs have been bowled as laid out in the market specific information.</p>

        <p>8. Cricket Limited Over matches :- In the event of a new toss taking place on a scheduled reserve day for a
            limited overs match all bets that were placed after 30 minutes before the original scheduled start of play
            on the first day will be made void. This rule relates to all markets except those that have been
            unconditionally determined (e.g. in the win the toss and toss combination markets).</p>
    </div>
    <div class="modal-footer">
        <div class="row w-100">
            <div class="col-12 text-center">
                <button type="button" class="btn btn-outline-danger" (click)="modalRef?.hide()">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>